import { render, staticRenderFns } from "./LecturersElRegister.vue?vue&type=template&id=546d4fb7&scoped=true"
import script from "./LecturersElRegister.vue?vue&type=script&lang=js"
export * from "./LecturersElRegister.vue?vue&type=script&lang=js"
import style0 from "./LecturersElRegister.vue?vue&type=style&index=0&id=546d4fb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546d4fb7",
  null
  
)

export default component.exports